import { useLoggedInEmployeeProfile } from '~/components/Auth';
import { useEmployeeProfile } from '~/data/employeeProfile';
import { EmployeeProfileDto } from '~/services/Http/client.people.generated';

export enum EmployeePictureEditMode {
  Logged = 'logged',
  Selected = 'selected',
}

export const useEmployeeProfileForPictureEdit = (props: {
  employeeId?: number;
}): {
  employeeProfile: EmployeeProfileDto | undefined;
  pictureEditMode: EmployeePictureEditMode;
  isLoading: boolean;
} => {
  const { employeeId } = props;
  const loggedProfile = useLoggedInEmployeeProfile();
  const { profile, isLoading } = useEmployeeProfile();

  if (!!employeeId) {
    return {
      isLoading,
      employeeProfile: profile?.id === employeeId ? profile : undefined,
      pictureEditMode: EmployeePictureEditMode.Selected,
    };
  }

  return {
    isLoading: false,
    employeeProfile: loggedProfile,
    pictureEditMode: EmployeePictureEditMode.Logged,
  };
};
